import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "tag", "small", "wide", "disabled", "primary", "secondary", "tertiary", "danger", "children"];
import React, { forwardRef } from 'react';
import { useComponentTheme } from '../../utils/hooks';
import { useButtonClassName } from './utils';
import { ButtonRoot } from './style';
import { buttonDefaultTheme } from './theme';
import { BUTTON_CLASS_PREFIX } from './constants';
export var Button = forwardRef(function Button(_ref, ref) {
  var className = _ref.className,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'button' : _ref$tag,
      small = _ref.small,
      wide = _ref.wide,
      disabled = _ref.disabled,
      primary = _ref.primary,
      secondary = _ref.secondary,
      tertiary = _ref.tertiary,
      danger = _ref.danger,
      children = _ref.children,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(BUTTON_CLASS_PREFIX, buttonDefaultTheme);
  var classNameRoot = useButtonClassName(BUTTON_CLASS_PREFIX, className, disabled, small, wide, primary, secondary, tertiary, danger);
  return React.createElement(ButtonRoot, Object.assign({}, restProps, {
    disabled: disabled,
    small: small,
    wide: wide,
    primary: primary,
    secondary: secondary,
    tertiary: tertiary,
    danger: danger,
    theme: theme,
    className: classNameRoot
  }), function (forwardedProps) {
    return React.createElement(Tag, Object.assign({}, forwardedProps, {
      ref: ref
    }), children);
  });
});
Button.defaultProps = {
  primary: true,
  secondary: false,
  tertiary: false,
  danger: false,
  small: false,
  wide: false,
  tag: 'button',
  type: 'button',
  disabled: false
};